<template>
  <div :class="className" :style="{height:height,width:width,margin:margin}"/>
</template>

<script>
import resize from '@/mixin/resize'

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '260px'
    },
    margin: {
      type: String,
      default: '0'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chart: null
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val)
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      this.chart = this.$echarts.init(this.$el, 'macarons')
      this.setOptions(this.chartData)
    },
    setOptions(chartData) {
      for (let item of chartData.v_92740017) {
        item.value = this.$formatInputMoney(item.value)
      }
      let other = (chartData.v_92740017[0].value * 100 - chartData.v_92740017[1].value * 100 - chartData.v_92740017[2].value * 100 - chartData.v_92740017[3].value * 100) / 100
      this.chart.setOption({
        tooltip: {
          trigger: 'item',
          formatter: '<div class="flex vertical jstart astart">\n' +
              '    <div class="flex acenter mb10">\n' +
              '      <div style="width: 8px;height: 8px;background: #3371C5;border-radius: 50%"></div>\n' +
              '      <span class="font-14 color-9 ml10 mr10">{b}</span>\n' +
              '      <span class="font-14 color-9">{d}%</span>\n' +
              '    </div>\n' +
              '    <span class="font-14 fw-600 color-0">￥{c}</span>\n' +
              '  </div>'
        },
        legend: {
          top: 'middle',
          right: 10,
          orient: 'vertical',
          selectedMode: false,
          textStyle: {
            overflow: 'break',
            width: 90
          }
        },
        series: [
          {
            name: '薪资构成比例',
            type: 'pie',
            width: 240,
            height: 240,
            top: 'middle',
            left: 30,
            radius: ['65%', '80%'],
            itemStyle: {
              borderRadius: 4,
              borderColor: '#FFFFFF',
              borderWidth: 2
            },
            label: {
              show: true,
              position: 'center',
              // 在文本中，可以对部分文本采用 rich 中定义样式。
              // 这里需要在文本中使用标记符号：
              // `{styleName|text content text content}` 标记样式名。
              // 注意，换行仍是使用 '\n'。
              formatter: [
                `{a|￥${chartData.v_92740017[0].value}}`,
                `{b|${this.$t('perCapitaLaborCost')}}`
              ].join('\n'),
              rich: {
                a: {
                  color: '#1C1C1C',
                  fontSize: 24,
                  fontWeight: 600,
                  padding: [18, 0, 18, 0]
                },
                b: {
                  color: '#999999',
                  fontSize: 14,
                  fontWeight: 400
                }
              }
            },
            emphasis: {},
            labelLine: {
              show: false
            },
            data: [
              { value: chartData.v_92740017[1].value, name: this.$t('netSalary'), zhName: '实发薪资' },
              { value: chartData.v_92740017[2].value, name: this.$t('socialSecurityAndProvidentFund'), zhName: '社保公积金' },
              { value: chartData.v_92740017[3].value, name: this.$t('IIT'), zhName: '个人所得税' },
              { value: other, name: this.$t('others') }
            ]
          }
        ]
      })
    }
  }
}
</script>
